/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import {
  getMonth,
  prevMonth,
  nextMonth,
  daysInMonth,
  WEEKDAYS,
  getDateMethod,
}                from 'lib/DateUtils';
import PropTypes from 'prop-types';
import React     from 'react';
import moment from 'moment';
import Icon      from 'components/Icon/Icon.react';
import styles    from 'components/Calendar/Calendar.scss';

export default class Calendar extends React.Component {
  constructor(props) {
    super();
    let now = props.value || new Date();
    this.state = {
      currentMonth: new Date(now[getDateMethod(props.local, 'getFullYear')](), now[getDateMethod(props.local, 'getMonth')](), 1)
    };
  }

  componentWillReceiveProps(props) {
    if (props.value) {
      this.setState({
        currentMonth: new Date(props.value[getDateMethod(props.local, 'getFullYear')](), props.value[getDateMethod(props.local, 'getMonth')](), 1)
      });
    }
  }

  handleNext() {
    this.setState({
      currentMonth: nextMonth(this.state.currentMonth)
    });
  }

  handlePrev() {
    this.setState({
      currentMonth: prevMonth(this.state.currentMonth)
    });
  }

  renderDays() {
    const currentMonth = moment(this.state.currentMonth).format('MM') === moment(this.props.selectedDays).format('MM');

    let isValueMonth = (
      this.props.value &&
      this.props.value[getDateMethod(this.props.local, 'getFullYear')]() === this.state.currentMonth.getFullYear() &&
      this.props.value[getDateMethod(this.props.local, 'getMonth')]() === this.state.currentMonth.getMonth()
    );

    let offset = this.state.currentMonth.getDay();
    let days = daysInMonth(this.state.currentMonth);
    let labels = [];

    for (let i = 0; i < offset; i++) {
      labels.push(<span key={'pad' + i} />);
    }

    for (let i = 1; i <= days; i++) {
      let isSelected = isValueMonth && (this.props.value[getDateMethod(this.props.local, 'getDate')]() === i);

      // let shouldMarkedSelectedDays = this.props.valueStart ? this.props.valueStart[getDateMethod(this.props.local, 'getDate')]() : null;
      // let endDate = this.props.value[getDateMethod(this.props.local, 'getDate')]();
      // let ebasi = this.state.currentMonth.getMonth() < this.props.value[getDateMethod(this.props.local, 'getMonth')]()
      // let styleMarkedSelectedDays = ((isValueMonth && shouldMarkedSelectedDays && shouldMarkedSelectedDays < i && i < endDate) || ebasi) ? styles.s : '';

      let endClass = '';

      if(currentMonth && Number(moment(this.props.selectedDays).format('D')) === i) {
        endClass = styles.end;
      }


      let className = isSelected ? styles.selected : '';
      let onChange = this.props.onChange.bind(
        null,
        this.props.local ?
          new Date(this.state.currentMonth.getFullYear(), this.state.currentMonth.getMonth(), i) :
          new Date(Date.UTC(this.state.currentMonth.getFullYear(), this.state.currentMonth.getMonth(), i))
      );
      labels.push(
        <a href='javascript:;' role='button' key={'day' + i} className={[styles.day, className, endClass].join(' ')} onClick={onChange}>{i}</a>
      );
    }
    let classes = [styles.days];
    if (isValueMonth && this.props.shadeBefore) {
      classes.push(styles.shadeBefore);
    }
    if (isValueMonth && this.props.shadeAfter) {
      classes.push(styles.shadeAfter);
    }

    if (
      this.props.shadeAfter &&
      moment(this.state.currentMonth).isAfter(moment(this.props.value).subtract(1, 'months'))
    ) {
      classes.push(styles.shadeAfterMonth);
    }
    return <div className={classes.join(' ')}>{labels}</div>;
  }

  renderMonth() {
    const { range, shadeAfter, value } = this.props;

    let isAfter = true;
    let isBefore = true;

    if(range) {
      const compareMonthBefore = moment(this.state.currentMonth).add(1, 'months');
      const compareMonthAfter = moment(this.state.currentMonth);
      const startDate   = moment().subtract(range[0], range[1]);
      const endDate     = moment();

      isBefore = compareMonthBefore.isBefore(endDate);
      isAfter = compareMonthAfter.isAfter(startDate);
    }

    return (
      <div className={styles.month}>
        {
          isAfter &&
            <a href='javascript:;' role='button' onClick={this.handlePrev.bind(this)}>
              <Icon name='icon-arrow-left' width={14} height={14} colored={true} />
            </a>

        }

        <div>{getMonth(this.state.currentMonth.getMonth()) + ' ' + this.state.currentMonth.getFullYear()}</div>

        {
          isBefore &&
            <a href='javascript:;' role='button' onClick={this.handleNext.bind(this)}>
              <Icon name='icon-arrow-right' width={14} height={14} colored={true} />
            </a>
        }

      </div>
    );
  }

  renderWeekdays() {
    return (
      <div className={styles.weekdays}>
        {WEEKDAYS.map((w) => <span key={w}>{w.substr(0, 2)}</span>)}
      </div>
    );
  }

  render() {
    return (
      <div className={styles.calendar}>
        {this.renderMonth()}
        {this.renderWeekdays()}
        {this.renderDays()}
      </div>
    );
  }
}

Calendar.propTypes = {
  value: PropTypes.instanceOf(Date),
  onChange: PropTypes.func.isRequired,
  shadeBefore: PropTypes.bool,
  shadeAfter: PropTypes.bool,
}
